import Col from "react-bootstrap/Col";
import { useAppSelector } from "../../../services/hooks";
import { formatPrice } from "../../../helpers/formatPrice";
import { useTranslation } from "react-i18next";

export default function ProductInfoPrices() {
    const { t } = useTranslation('productPage')
    const logged = useAppSelector((state) => state.user.logged)
    const prices = useAppSelector((state) => state.product.data?.price)
    const currency = useAppSelector((state) => state.user.currency)
    const unit = useAppSelector((state) => state.product.data.unit)

    return (<>
        <h2 className="my-0 mt-md-4 text-success">
            <strong>
                {prices?.net &&
                    formatPrice(prices.net, currency)}
            </strong>
        </h2>
        <Col xs={12} className="mb-2 fw-bold text-success">
            <small>
                {logged
                    ? t('prices.net')
                    : t('prices.guest')
                }
            </small>
        </Col>
        <Col xs={7} className="text-end p-0">
            <small>
                {t('prices.catalog.net')}
            </small>
        </Col>
        <Col xs={5} className="text-start ps-1">
            <small>
                <strong>
                    {prices?.catalog.net &&
                        formatPrice(prices.catalog.net, currency)}
                </strong>
            </small>
        </Col>
        <Col xs={7} className="text-end p-0">
            <small>
                {t('prices.catalog.gross')}
            </small>
        </Col>
        <Col xs={5} className="text-start ps-1">
            <small>
                <strong>
                    {prices?.catalog.gross &&
                        formatPrice(prices.catalog.gross, currency)}
                </strong>
            </small>
        </Col>
        <hr className="my-2 w-50 mx-auto" />
        <span className="bi bi-moisture fs-5">
            <strong className="p-2">{t('prices.for') + ' '}{unit}</strong>
            <br />
        </span>
    </>)
}